module.exports = __webpack_public_path__ + "static/media/6c790f1b6ed8a5a00e3bcee28ede4fba.7fd097cb.jpg";